import React, { useEffect, useRef, useState } from 'react'
import EditMenu from '../editMenu'
import { withTheme } from 'theming'
// import { Link } from 'react-router-dom'
import AddSection from '../addSection'
import useTemplateHook from '../templateHook'
import { useTranslation } from 'react-i18next'
import CustomImage from '../../customImage/customImage'
import { isEmpty } from 'lodash'
import styled from '@emotion/styled'
import MobileNavDropDown from '../../mobileNavDropDown'
import NavBarDropDown from '../../navbarDropdown'
import { useLocation } from 'react-router'
import SearchIcon3D from '../imgComponents/searchIcon3D'
import PrayerTimeNew from '../../prayerTime/prayerTimeNew'

const StyledHeading = styled.div`
  .text-color {
    color: ${(props) => (props.isOpened ? props.hoverColor : props.color)};
  }
  .text-color:hover {
    color: ${(props) => props.hoverColor};
  }
`
const StyledListItem = styled.li`
  .dropdown-list {
    background-color: ${(props) => props.background};
  }
  .dropdown-list:hover {
    background-color: ${(props) => props.backgroundHover};
  }
`

const IkimHeader1 = ({
  componentData,
  modifyData,
  setModalState,
  isEdit,
  onDelete,
  theme,
  onAdd,
  onSwap,
}) => {
  const { t } = useTranslation()
  const { data, id } = componentData
  const [profileToggle, setProfileToggle] = useState(false)
  const [openMobileMenu, setOpenMobileMenu] = useState(false)
  const { customNavigate, isLogin, userObj, getTemplateImage, getRandomBgGradient } =
    useTemplateHook()
  const [hoverState, setHoverState] = useState('')
  const [searchText, setSearchText] = useState('')
  const [activeTabIndex, setActiveTabIndex] = useState('')
  // const [searchBarHover, setSearchBarHover] = useState(false)
  const [searchBarShow, setSearchBarShow] = useState(false)

  const [drops, setDrops] = useState(data.site_map.map((dat) => ({ opened: false })))
  const location = useLocation()
  const isHomePage = location.pathname === '/' || location.pathname === '/home'

  const inputRef = useRef(null)

  const handleDropDown = (selectedDropDownIndex) => {
    let tempDrops = drops
    if (tempDrops[selectedDropDownIndex].opened) tempDrops[selectedDropDownIndex].opened = false
    else tempDrops[selectedDropDownIndex].opened = true
    setDrops([...tempDrops])
  }

  const handleBlurDropDown = (blurDropDownIndex) => {
    let tempDrops = drops
    tempDrops[blurDropDownIndex].opened = false
    setDrops([...tempDrops])
  }

  useEffect(() => {
    if (searchBarShow && inputRef.current) {
      inputRef.current.focus()
    }
  }, [searchBarShow])

  useEffect(() => {
    setDrops(data.site_map.map((dat) => ({ opened: false })))
  }, [data])

  const handleModal = () => {
    setModalState({
      keyID: id,
      modalData: data,
    })
  }
  const handleAddModal = () => {
    onAdd({
      keyID: id,
      modalData: data,
    })
  }

  const handleHoverItems = (name) => {
    if (!isEdit) return
    setHoverState(name)
  }

  const handleSearchButton = () => {
    if (searchText) {
      customNavigate('DIRECT', `search?search_text=${searchText}`, isEdit)
      // setOpenMobileSearch(false)
      setSearchText('')
      setOpenMobileMenu(false)
      setSearchBarShow(false)
    }
  }

  const handleSearch = (event) => {
    if (event.key === 'Enter' && searchText) {
      customNavigate('DIRECT', `search?search_text=${searchText}`, isEdit)
      setSearchText('')
      setOpenMobileMenu(false)
      setSearchBarShow(false)
    }
  }

  const handleRedirect = (linkObj) => {
    setOpenMobileMenu(false)
    customNavigate('INDIRECT', linkObj, isEdit)
  }

  const getStyleValue = (parentKey, childKey, defaultValue) => {
    if (!data?.style_config) {
      return defaultValue ? defaultValue : ''
    }

    let tempArr = data?.style_config[parentKey]?.data.filter((info) => info.key === childKey)

    return !isEmpty(tempArr) ? (tempArr[0].value ? tempArr[0].value : defaultValue) : defaultValue
  }

  return (
    <>
      <div
        style={{
          backgroundColor: getStyleValue('component_background', 'primary_color', '#000000'),
          height: isHomePage ? '76px' : '53px',
        }}
        className={`w-full`}
      >{`.`}</div>
      <header
        className={` ${isEdit ? 'fixed' : 'fixed'} z-50 w-full ${
          isEdit && hoverState && 'component-hover-class'
        } flex flex-col `}
        style={{}}
        onMouseEnter={() => handleHoverItems(`TOP`)}
        onMouseLeave={() => handleHoverItems('')}
      >
        {isEdit && hoverState.length > 0 && (
          <EditMenu
            onEdit={handleModal}
            onDelete={() => onDelete(id)}
            onMoveUp={() => onSwap(id, 'up')}
            onMoveDown={() => onSwap(id, 'down')}
          />
        )}

        <nav
          style={{
            background: `${getStyleValue('component_background', 'primary_color', '#000000')}`,
          }}
          className={` px-[8px] lg:px-[1vw] xl:px-[2.298vw] 2xl:px-[2vw]  w-full lg:h-[56px] `}
        >
          <div
            className={`${
              searchBarShow
                ? 'w-full'
                : 'flex flex-wrap justify-between items-center mx-auto max-w-screen-auto'
            }  `}
          >
            <div className={`${searchBarShow ? 'hidden' : 'flex'} xl:items-center z-0`}>
              <div
                className="w-[100px] md:w-[100px] xl:w-[191px]"
                onClick={() => customNavigate('DIRECT', '/home', isEdit)}
              >
                <CustomImage
                  imageUrl={getTemplateImage(data?.logo_s3key)}
                  imgClass="cursor-pointer w-full"
                  imgStyle={{
                    backgroundColor: 'transparent',
                    aspectRatio: '191/51',
                  }}
                  loaderClass=" cursor-pointer w-full"
                  loaderStyle={{
                    background: '#5A5A5A50',
                    aspectRatio: '191/51',
                  }}
                  imgAlt={'Logo'}
                />
              </div>
              {/* nav bar  */}
              <div
                className="hidden justify-between items-center w-full xl:flex lg:w-auto ml-[35px]"
                id="mobile-menu-2"
              >
                <ul
                  style={{
                    listStyle: 'none',
                    margin: 0,
                    padding: 0,
                    transition: 'all 0.3s ease-in-out',
                  }}
                  className="flex items-center"
                >
                  {[...data?.site_map].map((siteMapItem, idx) => (
                    <div
                      key={idx}
                      className={`group xl:relative static h-full ${idx && 'ml-[18px]'}`}
                      // style={{ outline: '2px solid red' }}
                      onClick={
                        siteMapItem?.link?.type.length > 0
                          ? () => {
                              setActiveTabIndex(idx)
                              handleRedirect(siteMapItem?.link)
                            }
                          : () => {
                              setActiveTabIndex('')
                              handleDropDown(idx)
                            }
                      }
                      onBlur={(e) => {
                        const currentTarget = e.currentTarget
                        // Give browser time to focus the next element
                        requestAnimationFrame(() => {
                          // Check if the new focused element is a child of the original container
                          if (!currentTarget.contains(document.activeElement)) {
                            // setShowsDropdown(false)
                            handleBlurDropDown(idx)
                          }
                        })
                      }}
                      tabIndex={100}
                    >
                      <StyledHeading
                        color={getStyleValue('title_primary', 'color', '#C0C0C0')}
                        hoverColor={getStyleValue('title_primary', 'hover_color', 'white')}
                        isOpened={drops[idx]?.opened || activeTabIndex === idx}
                      >
                        <button
                          className={`text-color cursor-pointer  xl:w-max w-full flex xl:justify-start justify-center items-center`}
                          style={{
                            border: 'none',
                            // padding: '0 0.4vw',
                            background: 'transparent',
                          }}
                        >
                          <span
                            className={` ${
                              drops[idx]?.opened || activeTabIndex === idx ? 'underline' : ''
                            } ${getStyleValue(
                              'title_primary',
                              'font_format',
                              '',
                            )} text-[13px] 2xl:text-base `}
                            style={{
                              textDecorationColor: getStyleValue(
                                'highlighter_color',
                                'color',
                                '#fecc00',
                              ),
                              textUnderlineOffset: '8px',
                              fontFamily: getStyleValue('title_primary', 'font', ''),
                              textAlign: getStyleValue('title_primary', 'alignment', ''),
                              textDecorationThickness: '2px',
                            }}
                          >
                            {siteMapItem?.title}
                          </span>

                          {siteMapItem?.sub_heading_data.some((item) => item.text.length > 0) && (
                            <svg
                              className={`${
                                drops[idx]?.opened ? 'rotate-profile-arrow' : 'reset-profile-arrow'
                              } w-3 h-3 ml-1`}
                              fill="none"
                              stroke="currentColor"
                              viewBox="0 0 24 24"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth="2"
                                d="M19 9l-7 7-7-7"
                              />
                            </svg>
                          )}
                        </button>
                      </StyledHeading>
                      <ul
                        className={` w-auto absolute`}
                        style={{
                          paddingInlineStart: '0',
                          marginBottom: '0',
                          color: '#fff',
                          whiteSpace: 'nowrap',
                          marginTop: '10px',
                          listStyle: 'none',
                          minWidth: '90%',
                          transition: 'all 0.3s ease-in-out',
                          visibility: drops[idx]?.opened ? 'visible' : 'hidden',
                          opacity: drops[idx]?.opened ? 1 : 0,
                        }}
                      >
                        {siteMapItem?.sub_heading_data.map((item, idx) => {
                          return (
                            item?.text.length > 0 && (
                              <StyledListItem
                                background={`${getStyleValue(
                                  'component_background',
                                  'primary_color',
                                  '#000000',
                                )}`}
                                backgroundHover={`${getStyleValue(
                                  'highlighter_color',
                                  'color',
                                  '#fecc00',
                                )}`}
                              >
                                <li
                                  className={`dropdown-list cursor-pointer w-full h-max flex xl:justify-start text-xs 2xl:text-[12.5px] items-center py-2.5 xl:pl-6 pl-0 xl:pr-6 pr-0  hover:text-white ${getStyleValue(
                                    'title_secondary',
                                    'font_format',
                                    '',
                                  )}`}
                                  style={{
                                    color: getStyleValue('title_secondary', 'color', 'white'),
                                    fontFamily: getStyleValue('title_secondary', 'font', ''),
                                  }}
                                  key={idx}
                                  onClick={() => {
                                    // handleCategoryClick(item._id, item.name)
                                    handleRedirect(item?.link)
                                  }}
                                >
                                  {item.text}
                                </li>
                              </StyledListItem>
                            )
                          )
                        })}
                      </ul>
                    </div>
                  ))}
                </ul>
              </div>
            </div>
            {/* search and login button */}
            <div
              className={` ${
                searchBarShow
                  ? 'flex items-center justify-center w-full'
                  : 'flex items-center justify-between'
              }  z-10`}
              style={{
                position: 'relative',

                // outline: '2px solid lime',
              }}
            >
              <div
                className={`group flex-shrink-0 xl:h-11 lg:h-10 h-8 ${
                  searchBarShow ? ' w-[88%] ' : ''
                }   xl:flex `}
                style={{
                  position: searchBarShow ? 'relative' : 'absolute',
                  right: searchBarShow ? 'auto' : '100%',
                  transition: searchBarShow ? '500ms' : '0ms',
                  // transition: 'width 0.5s ease-in-out',
                  // visibility: searchBarShow ? 'visible' : 'hidden',
                  opacity: searchBarShow ? 1 : 0,
                  // overflow: 'hidden',
                  // marginRight: '0.52vw',
                }}
                onClick={searchBarShow ? null : () => setSearchBarShow(true)}
              >
                <input
                  ref={inputRef}
                  type="text"
                  className={`${
                    searchBarShow ? 'block' : 'hidden'
                  }  bg-transparent flex-shrink-0 outline-none xl:px-4 px-2 xl:py-2.5 lg:py-1.5 py-[0] w-full lg:text-base text-sm placeholder:italic`}
                  placeholder={t('search_here')}
                  style={{
                    outline: 'none',
                    color: getStyleValue('add_btn1', 'color', '#fff'),
                    fontFamily: 'Arial',
                    fontWeight: 'normal',
                    borderBottom: `1px solid ${getStyleValue('add_btn1', 'color', '#fff')}`,
                  }}
                  disabled={isEdit}
                  value={searchText}
                  onChange={(e) => setSearchText(e.target.value)}
                  onKeyPress={(e) => handleSearch(e)}
                />

                {searchBarShow ? (
                  <button
                    className="absolute p-1 right-0 xl:text-3xl font-semibold"
                    onClick={() => setSearchBarShow((prev) => !prev)}
                  >
                    <span
                      style={{ color: getStyleValue('add_btn1', 'color', '#fff') }}
                      className="   text-xl xl:text-2xl block outline-none focus:outline-none"
                    >
                      ×
                    </span>
                  </button>
                ) : null}
              </div>

              {!searchBarShow ? (
                <>
                  <div
                    className="w-[10.7px] 2xl:w-[13px] m-auto flex-shrink-0 cursor-pointer hidden xl:block"
                    style={{
                      transition: '500ms',
                      transform: searchBarShow === true ? 'translateX(-20%)' : '',
                    }}
                    onClick={handleSearchButton}
                  >
                    <SearchIcon3D
                      imgClass="w-full"
                      imgStyle={{}}
                      color={getStyleValue('search_color', 'color', 'white')}
                    />
                  </div>

                  <p
                    onClick={searchBarShow ? null : () => setSearchBarShow(true)}
                    style={{ color: getStyleValue('search_color', 'color', 'white') }}
                    className="hidden xl:block text-xs xl:text-[13px] 2xl:text-[15px] ml-2 opacity-70 hover:opacity-100 cursor-pointer"
                  >
                    {data?.search_text?.text}
                  </p>
                  <div
                    style={{
                      border: `0.5px solid ${getStyleValue('search_color', 'color', 'white')}`,
                      height: '15px',
                    }}
                    className="hidden lg:block mx-[18px] opacity-70"
                  ></div>

                  <button
                    onClick={() => handleRedirect(data?.subscribe_btn?.link)}
                    style={{
                      backgroundImage: `linear-gradient(to ${getStyleValue(
                        'subscribe_btn',
                        'gradient',
                        'right',
                      )}, ${getStyleValue(
                        'subscribe_btn',
                        'primary_color',
                        '#8e0000',
                      )}, ${getStyleValue('subscribe_btn', 'secondary_color', '#ff0000')})`,

                      color: getStyleValue('subscribe_btn', 'text_color', theme.c6),
                      //   borderRadius: '4px',
                      height: '30px',
                    }}
                    className=" border-0 shadow-xl font-medium text-xs xl:text-[13px] 2xl:text-[15px] px-3"
                  >
                    {data?.subscribe_btn?.text}
                  </button>

                  <div
                    style={{
                      border: `0.5px solid ${getStyleValue('add_btn1', 'color', 'white')}`,
                      height: '15px',
                    }}
                    className="hidden lg:block mx-[18px] opacity-70"
                  ></div>

                  {!isLogin ? (
                    <div className="hidden xl:flex justify-between items-center text-xs xl:text-[13px] 2xl:text-[15px]">
                      <span
                        onClick={() => handleRedirect(data?.add_btn1?.link)}
                        className={` block lg:mr-[21px] cursor-pointer opacity-70 hover:opacity-100 `}
                        style={{
                          color: getStyleValue('add_btn1', 'color', 'white'),
                        }}
                      >
                        {data?.add_btn1?.text}
                      </span>

                      <button
                        onClick={() => handleRedirect(data?.add_btn2?.link)}
                        style={{
                          backgroundImage: `linear-gradient(to ${getStyleValue(
                            'add_btn2',
                            'gradient',
                            'right',
                          )}, ${getStyleValue(
                            'add_btn2',
                            'primary_color',
                            '#8e0000',
                          )}, ${getStyleValue('add_btn2', 'secondary_color', '#ff0000')})`,

                          color: getStyleValue('add_btn2', 'text_color', theme.c6),
                          //   borderRadius: '4px',
                          height: '30px',
                        }}
                        className="border-0 shadow-xl font-medium px-3"
                      >
                        {data?.add_btn2?.text}
                      </button>
                    </div>
                  ) : (
                    <div
                      className="flex justify-center items-center"
                      onClick={() => {
                        setProfileToggle(!profileToggle)
                        setOpenMobileMenu(false)
                      }}
                      onBlur={(e) => {
                        const currentTarget = e.currentTarget
                        // Give browser time to focus the next element
                        requestAnimationFrame(() => {
                          // Check if the new focused element is a child of the original container
                          if (!currentTarget.contains(document.activeElement)) {
                            setProfileToggle(false)
                            setOpenMobileMenu(false)
                          }
                        })
                      }}
                      tabIndex={3}
                    >
                      <div className="relative">
                        <div className="flex justify-center items-center space-x-3 cursor-pointer">
                          {/* <img
                        src={ProfileIcon}
                        alt="ProfileIcon"
                        className="w-7 h-7 md:w-10 md:h-10"
                      /> */}

                          <div
                            style={{ color: '#060606' }}
                            className="w-6 h-6 xl:w-[27px] xl:h-[27px] font-semibold flex items-center  justify-center rounded-md relative"
                          >
                            <img
                              src={getRandomBgGradient(userObj?.name)}
                              className="w-full h-full"
                              alt="getRandomBgGradient"
                            />
                            <p className="absolute text-sm xl:text-[15px]">
                              {Array.from(`${userObj?.name}`.toUpperCase())[0]}
                            </p>
                          </div>
                          <div className=" font-semibold ">
                            <div
                              style={{ opacity: '0.85' }}
                              className="flex text-sm xl:text-[13px] 2xl:text-sm text-white"
                            >
                              <span>{userObj?.name ? userObj?.name.split(' ')[0] : ''}</span>
                              <svg
                                className={
                                  profileToggle
                                    ? 'rotate-profile-arrow w-4 h-4 ml-2 mt-1'
                                    : 'reset-profile-arrow w-4 h-4 ml-2 mt-1'
                                }
                                fill="none"
                                stroke="currentColor"
                                viewBox="0 0 24 24"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  strokeWidth="2"
                                  d="M19 9l-7 7-7-7"
                                />
                              </svg>
                            </div>
                          </div>
                        </div>
                        {profileToggle ? (
                          <NavBarDropDown
                            backgroundColor={getStyleValue(
                              'component_background',
                              'primary_color',
                              '#000000',
                            )}
                            titleColor={getStyleValue('title_primary', 'color', 'white')}
                          />
                        ) : null}
                      </div>
                    </div>
                  )}

                  <button
                    type="button"
                    className="xl:hidden flex items-center p-2 ml-1 rounded-lg border-0"
                    onClick={() => {
                      setOpenMobileMenu(!openMobileMenu)
                      setProfileToggle(false)
                    }}
                  >
                    <svg
                      className="w-6 h-6"
                      fill="currentColor"
                      viewBox="0 0 20 20"
                      xmlns="http://www.w3.org/2000/svg"
                      style={{ fill: getStyleValue('add_btn1', 'color', theme.c5) }}
                    >
                      <path
                        fillRule="evenodd"
                        d="M3 5a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 10a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 15a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1z"
                        clipRule="evenodd"
                      />
                    </svg>
                  </button>
                </>
              ) : null}
            </div>

            {isHomePage ? (
              <div className="block xl:hidden">
                <PrayerTimeNew
                  bgColor1={`${getStyleValue('component_background', 'prayer_color1', '#0341F0')}`}
                  bgColor2={`${getStyleValue('component_background', 'prayer_color2', '#266EF0')}`}
                  bgColor3={`${getStyleValue('component_background', 'prayer_color3', '#F9AF2E')}`}
                  fontColor={`${getStyleValue('component_background', 'prayer_text', '#000000')}`}
                />
              </div>
            ) : null}

            <div
              className={openMobileMenu && !profileToggle ? 'w-full' : 'hidden bg-slate-50'}
              style={{
                borderBottom: `1.5px solid ${getStyleValue('add_btn1', 'color', theme.c5)}`,
              }}
            >
              <ul className=" divide-y ">
                <li
                  style={{ color: getStyleValue('add_btn1', 'color', theme.c5) }}
                  className="flex justify-center items-center pt-3 pb-2 px-6"
                >
                  <div className="relative w-full">
                    <input
                      style={{
                        border: `1px solid ${getStyleValue('add_btn1', 'color', theme.c5)}`,
                        outline: 'none',
                        color: getStyleValue('add_btn1', 'color', theme.c5),
                      }}
                      value={searchText}
                      onChange={(e) => setSearchText(e.target.value)}
                      onKeyPress={(e) => handleSearch(e)}
                      className={`w-full bg-transparent px-2 py-1 rounded-md text-sm italic focus:outline-none`}
                      name="search"
                      placeholder={t('search_here')}
                      disabled={isEdit}
                    />
                    <button
                      type="submit"
                      style={{ right: '5px' }}
                      className="absolute top-2 bg-transparent"
                      onClick={handleSearchButton}
                    >
                      <svg
                        className="text-white h-4 w-4 "
                        xmlns="http://www.w3.org/2000/svg"
                        version="1.1"
                        id="Capa_1"
                        x="0px"
                        y="0px"
                        viewBox="0 0 56.966 56.966"
                        style={{ enableBackground: 'new 0 0 56.966 56.966', fill: 'white' }}
                        xmlSpace="preserve"
                        width="512px"
                        height="512px"
                      >
                        <path d="M55.146,51.887L41.588,37.786c3.486-4.144,5.396-9.358,5.396-14.786c0-12.682-10.318-23-23-23s-23,10.318-23,23  s10.318,23,23,23c4.761,0,9.298-1.436,13.177-4.162l13.661,14.208c0.571,0.593,1.339,0.92,2.162,0.92  c0.779,0,1.518-0.297,2.079-0.837C56.255,54.982,56.293,53.08,55.146,51.887z M23.984,6c9.374,0,17,7.626,17,17s-7.626,17-17,17  s-17-7.626-17-17S14.61,6,23.984,6z" />
                      </svg>
                    </button>
                  </div>
                </li>
                {data?.site_map.map((siteMapItem, idx) => (
                  <div
                    key={idx}
                    className="group xl:relative static h-full py-2 "
                    // style={{ outline: '2px solid red' }}
                    onClick={
                      siteMapItem?.link?.type.length > 0
                        ? () => handleRedirect(siteMapItem?.link)
                        : () => handleDropDown(idx)
                    }
                    style={{
                      borderTop: `1.5px solid ${getStyleValue('add_btn1', 'color', theme.c5)}`,
                    }}
                    onBlur={(e) => {
                      const currentTarget = e.currentTarget
                      // Give browser time to focus the next element
                      requestAnimationFrame(() => {
                        // Check if the new focused element is a child of the original container
                        if (!currentTarget.contains(document.activeElement)) {
                          // setShowsDropdown(false)
                          handleBlurDropDown(idx)
                        }
                      })
                    }}
                    tabIndex={100}
                  >
                    <button
                      className={`xl:w-max w-full flex xl:justify-start justify-center items-center`}
                      style={{
                        border: 'none',
                        color: getStyleValue('title_primary', 'color', 'white'),
                        padding: '0 25px',
                      }}
                    >
                      <span
                        className={`${drops[idx]?.opened ? 'underline' : ''} ${getStyleValue(
                          'title_primary',
                          'font_format',
                          '',
                        )} text-sm lg:text-base header-menu-underline`}
                        style={{
                          textDecorationColor: getStyleValue(
                            'highlighter_color',
                            'color',
                            '#fecc00',
                          ),
                          textUnderlineOffset: '8px',
                          fontFamily: getStyleValue('title_primary', 'font', ''),
                          textAlign: getStyleValue('title_primary', 'alignment', ''),
                          textDecorationThickness: '2px',
                        }}
                      >
                        {siteMapItem?.title}
                      </span>
                      {siteMapItem?.sub_heading_data.some((item) => item.text.length > 0) && (
                        <svg
                          className={`${
                            drops[idx]?.opened ? 'rotate-profile-arrow' : 'reset-profile-arrow'
                          } w-4 h-4 ml-1`}
                          fill="none"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="2"
                            d="M19 9l-7 7-7-7"
                          />
                        </svg>
                      )}
                    </button>
                    <ul
                      className={`${drops[idx]?.opened ? 'block' : 'hidden'} 
                    xl:absolute static top-[100%] xl:w-auto w-full lg:-left-12 -left-6 xl:left-0`}
                      style={{
                        paddingInlineStart: '0',
                        marginBottom: '0',
                        color: '#fff',
                        whiteSpace: 'nowrap',
                      }}
                    >
                      {siteMapItem?.sub_heading_data.map((item, idx) => {
                        return (
                          item?.text.length > 0 && (
                            <li
                              className={`cursor-pointer font-bold w-full h-max flex xl:justify-start justify-center text-sm items-center py-2.5 xl:pl-6 pl-0 xl:pr-6 pr-0  hover:text-white ${
                                getStyleValue('title_secondary', 'font_format')
                                  ? getStyleValue('title_secondary', 'font_format')
                                  : ''
                              }`}
                              style={{
                                color: getStyleValue('title_secondary', 'color', 'white'),
                                fontFamily: getStyleValue('title_secondary', 'font', ''),
                                textAlign: getStyleValue('title_secondary', 'alignment', ''),
                              }}
                              key={idx}
                              onClick={() => {
                                // handleCategoryClick(item._id, item.name)
                                handleRedirect(item?.link)
                              }}
                            >
                              {item.text}
                            </li>
                          )
                        )
                      })}
                    </ul>
                  </div>
                ))}

                {!isLogin && (
                  <>
                    <li
                      style={{
                        borderTop: `1.5px solid ${getStyleValue('add_btn1', 'color', theme.c5)}`,
                      }}
                      className="flex justify-center items-center"
                      onClick={() => handleRedirect(data?.add_btn1?.link)}
                    >
                      <p className="text-white font-semibold text-sm block px-4 py-1 cursor-pointer user-dropdown-menu my-2">
                        {data?.add_btn1?.text}
                      </p>
                    </li>
                    <li
                      style={{
                        color: theme.c5,
                        borderTop: `1.5px solid ${getStyleValue('add_btn1', 'color', theme.c5)}`,
                      }}
                      className="flex justify-center items-center"
                    >
                      <button
                        onClick={() => handleRedirect(data?.add_btn2?.link)}
                        style={{
                          backgroundImage: `linear-gradient(to ${getStyleValue(
                            'add_btn2',
                            'gradient',
                            'right',
                          )}, ${getStyleValue(
                            'add_btn2',
                            'primary_color',
                            '#8e0000',
                          )}, ${getStyleValue('add_btn2', 'secondary_color', '#ff0000')})`,

                          color: getStyleValue('add_btn2', 'text_color', theme.c6),
                          borderRadius: '5px',
                        }}
                        className="border-0 shadow-xl font-medium  text-sm px-8 py-1 my-2"
                      >
                        {data?.add_btn2?.text}
                      </button>
                    </li>
                  </>
                )}
              </ul>
            </div>
            <div
              className={
                profileToggle && !openMobileMenu ? 'w-full block xl:hidden' : 'hidden bg-slate-50'
              }
              style={{
                borderBottom: `1.5px solid ${getStyleValue('add_btn1', 'color', theme.c5)}`,
              }}
            >
              <MobileNavDropDown
                titleColor={getStyleValue('title_primary', 'color', 'white')}
                borderTop={`1.5px solid ${getStyleValue('add_btn1', 'color', theme.c5)}`}
              />
            </div>
          </div>
        </nav>
        {isEdit && hoverState.length > 0 && <AddSection openAdd={handleAddModal} />}
        {isHomePage ? (
          <div className="hidden xl:block">
            <PrayerTimeNew
              bgColor1={`${getStyleValue('component_background', 'prayer_color1', '#0341F0')}`}
              bgColor2={`${getStyleValue('component_background', 'prayer_color2', '#266EF0')}`}
              bgColor3={`${getStyleValue('component_background', 'prayer_color3', '#F9AF2E')}`}
              fontColor={`${getStyleValue('component_background', 'prayer_text', '#000000')}`}
            />
          </div>
        ) : null}
      </header>
    </>
  )
}

export default withTheme(IkimHeader1)
